export default __webpack_public_path__ + "static/media/power-icon.1906e25d.svg";